import PropTypes from "prop-types";
import React, { useEffect, useState } from "react";
import Typography from "@material-ui/core/Typography";
import { makeStyles } from "@material-ui/core";
import { useTranslate } from "react-polyglot";

const useStyles = makeStyles(() => ({
  examStatus: {
    color: "#000",
    fontWeight: 600,
    whiteSpace: "nowrap",
    marginTop: 16,
  },
}));

/**
 * @param {Exam} exam
 */
const ExamStatusText = ({ exam }) => {
  const t = useTranslate();
  const classes = useStyles();
  const [examStatusText, setExamStatusText] = useState("");

  // prepare status data
  useEffect(() => {
    switch (exam.status) {
      case "finished_passed":
        setExamStatusText(t("exam.examPassed"));
        break;
      case "finished_not_passed":
        setExamStatusText(t("exam.examNotPassed"));
        break;
      case "finished_wait_homework":
        setExamStatusText(t("exam.waitHomeworks", { smart_count: exam.waitHomeworks }));
        break;
    }
  }, [exam, t]);

  return (
    <Typography className={classes.examStatus} variant="h6">
      {examStatusText}
    </Typography>
  );
};

ExamStatusText.propTypes = {
  exam: PropTypes.object.isRequired,
};

export default ExamStatusText;
